import React, { createContext, FC, useCallback, useContext, useState, ReactNode } from 'react'
import { DisputeInfoResponse, OrderResponse } from '@afterpaytouch/portal-api'

// @ts-ignore: OPERATION BLEED STOPPER
const noop = (): void => null

export enum DisputeInfoStep {
  Detail,
  SubmitEvidence,
}

export interface DisputeInfoModalContextProps {
  step: DisputeInfoStep
  setStep: (step: DisputeInfoStep) => void
  isSubmitEvidence: boolean
  setIsSubmitEvidence: (isSubmitEvidence: boolean) => void
  resetState: () => void
  closeModal: () => void
  disputeInfo: DisputeInfoResponse
  order: OrderResponse
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  refresh: () => void
}

export const disputeInfoModalContextDefaultValue: DisputeInfoModalContextProps = {
  step: DisputeInfoStep.Detail,
  setStep: noop,
  resetState: noop,
  closeModal: noop,
  // @ts-ignore: OPERATION BLEED STOPPER
  disputeInfo: null,
  // @ts-ignore: OPERATION BLEED STOPPER
  order: null,
  isLoading: false,
  setIsLoading: noop,
  refresh: noop,
  isSubmitEvidence: false,
  setIsSubmitEvidence: noop,
}

export const DisputeInfoModalContext = createContext<DisputeInfoModalContextProps>(disputeInfoModalContextDefaultValue)

export const useDisputeInfoModalContext = (): DisputeInfoModalContextProps => {
  return { ...useContext(DisputeInfoModalContext) }
}

export interface DisputeInfoModalProviderProps {
  disputeInfo: DisputeInfoResponse
  order: OrderResponse
  closeModal: () => void
  refresh: () => void
  children: ReactNode
}

export const DisputeInfoModalProvider: FC<DisputeInfoModalProviderProps> = ({ children, disputeInfo, closeModal, order, refresh }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isSubmitEvidence, setIsSubmitEvidence] = useState(false)
  const [step, setStep] = useState(DisputeInfoStep.Detail)
  const resetState = useCallback(() => {
    setIsLoading(false)
    setStep(DisputeInfoStep.Detail)
  }, [])

  const value = {
    resetState,
    closeModal,
    disputeInfo,
    order,
    isLoading,
    setIsLoading,
    step,
    setStep,
    refresh,
    isSubmitEvidence,
    setIsSubmitEvidence,
  }

  return <DisputeInfoModalContext.Provider value={value}>{children}</DisputeInfoModalContext.Provider>
}
